// src/App.js
import { useState } from 'react';
import { Form, Field, Button, Toast } from 'react-vant';
import { Helmet, history } from '@umijs/max';
import './index.less';
import { EyeO, ClosedEye } from '@react-vant/icons';
import { updatePwd } from '@/service/login';
import { validatePassword, validateIdCard } from '@/utils/validate';

const ForgetPassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // const back = () => {
  //   history.push('/login');
  // };
  // 验证身份证号
  // const validateIdCard = (_: any, value: any) => {
  //   if (!value) {
  //     return Promise.reject('请输入身份证号');
  //   }
  //
  //   // 简单身份证验证（实际项目中应使用更严格的验证）
  //   const idNumberPattern =
  //     /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
  //   if (!idNumberPattern.test(value)) {
  //     return Promise.reject('请输入有效的身份证号码');
  //   }
  //
  //   return Promise.resolve();
  // };

  // 验证密码强度
  // const validatePassword = (_: any, value: any) => {
  //   if (!value) {
  //     return Promise.reject('请输入密码');
  //   }
  //
  //   if (value.length < 6) {
  //     return Promise.reject('密码至少6位');
  //   }
  //
  //   // if (!/[A-Z]/.test(value)) {
  //   //   return Promise.reject('需包含大写字母');
  //   // }
  //
  //   // if (!/[a-z]/.test(value)) {
  //   //   return Promise.reject('需包含小写字母');
  //   // }
  //
  //   // if (!/[0-9]/.test(value)) {
  //   //   return Promise.reject('需包含数字');
  //   // }
  //
  //   return Promise.resolve();
  // };

  // 验证确认密码
  const validateConfirmPassword = (_: any, value: any) => {
    if (!value) {
      return Promise.reject('请确认密码');
    }

    if (value !== form.getFieldValue('password')) {
      return Promise.reject('两次输入的密码不一致');
    }

    return Promise.resolve();
  };

  const onFinish = (values: any) => {
    setLoading(true);
    console.log(form);
    const data = { ...values };
    data.openId = localStorage.getItem('userOpenId');
    updatePwd(data)
      .then((res: any) => {
        if (res && res.code === 200) {
          Toast.success('修改成功，请重新登录！');
          history.push('/login');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="register-container">
      <Helmet>
        <title>忘记密码</title>
      </Helmet>
      {/* <NavBar title="忘记密码" onClickLeft={back} zIndex='111' fixed/> */}

      <div className="register-form">
        <Form
          form={form}
          onFinish={onFinish}
          initialValues={{
            phonenumber: '',
            username: '',
            idNumber: '',
            password: '',
            confirmPassword: '',
          }}
        >
          <Form.Item
            name="phonenumber"
            label="手机号"
            rules={[{ required: true, message: '请输入手机号' }]}
          >
            <Field placeholder="请输入" clearable />
          </Form.Item>

          <Form.Item
            name="idNumber"
            label="身份证号"
            rules={[{ validator: validateIdCard }]}
          >
            <Field placeholder="请输入" clearable />
          </Form.Item>

          <Form.Item
            name="password"
            label="新密码"
            rules={[{ validator: validatePassword }]}
          >
            <Field
              type={showPassword ? 'text' : 'password'}
              placeholder="请输入"
              rightIcon={showPassword ? <EyeO /> : <ClosedEye />}
              onClickRightIcon={() => setShowPassword(!showPassword)}
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="确认新密码"
            rules={[{ validator: validateConfirmPassword }]}
          >
            <Field
              type={showConfirmPassword ? 'text' : 'password'}
              placeholder="请再次输入"
              rightIcon={showPassword ? <EyeO /> : <ClosedEye />}
              onClickRightIcon={() =>
                setShowConfirmPassword(!showConfirmPassword)
              }
            />
          </Form.Item>

          <div className="submit-btn">
            <Button
              round
              block
              type="primary"
              nativeType="submit"
              loading={loading}
              loadingText="提交中..."
            >
              提交
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ForgetPassword;
